// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-check-input {
    width: 16px;
    height: 16px;
    margin-right: 24px;
    border: solid 2px #636363;
}

.terms .form-check-input {
    margin-right: 0px;
}

.terms .form-check-input:checked[type=radio] {
    margin-top: 4px !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/learning/AdminModal.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".form-check-input {\n    width: 16px;\n    height: 16px;\n    margin-right: 24px;\n    border: solid 2px #636363;\n}\n\n.terms .form-check-input {\n    margin-right: 0px;\n}\n\n.terms .form-check-input:checked[type=radio] {\n    margin-top: 4px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
